import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { SubmittalJobMatchCalculation } from '../../../submittal/models/submittal-job-match-calculation.model';

export interface JobPercentagesState {
    percentages: SubmittalJobMatchCalculation[];
    loading: LoadingTypes;
}

const initialState: JobPercentagesState = {
    percentages: [],
    loading: LoadingTypes.INIT
};

export function liveNursesJobPercentagesReducer(state: JobPercentagesState, action: Action) {
    return createReducer(
        initialState,
        on(actions.loadJobPercentages, (state, action) => {
            return {
                ...state,
                recruiterId: action.recruiterId,
                loading: LoadingTypes.LOADING
            };
        }),

        on(actions.loadJobPercentagesSuccess, (state, action) => {
            return {
                ...state,
                percentages: [...action.percentages],
                loading: LoadingTypes.LOADED
            };
        }),

        on(actions.loadJobPercentagesFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        }))
    )(state, action);
}

export function reducer(state: JobPercentagesState | undefined, action: Action) {
    return liveNursesJobPercentagesReducer(state, action);
}
